import React from 'react';

import { RadioButtonGroupInput, DateInput,Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField } from 'admin-on-rest/lib/mui';
import Datagrid from './Datagrid';
const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  const d = new Date(match[1], parseInt(match[2])-1, match[3]);
  if (isNaN(d)) return;
  return d;
};

const dateParser = v => {
  // v is a `Date` object
  if (!(v instanceof Date) || isNaN(v)) return;
  const pad = '00';
  const yy = v.getFullYear().toString();
  const mm = ((v.getMonth() + 1).toString());
  const dd = v.getDate().toString();
  return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

var minDate=new Date();
minDate.setDate(minDate.getDate()-180);

const HafkadotFilter = (props) => (
    <Filter {...props} >
       
     
         <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.סיום" source="EndDate" options={{
    mode: 'landscape',
    maxDate: new Date(),
  minDate:minDate,
    okLabel: 'אישור',
    firstDayOfWeek:0,
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
      <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.התחלה" source="StartDate" options={{
    mode: 'landscape',
    maxDate: new Date(),
  minDate:minDate,
    okLabel: 'אישור',
    firstDayOfWeek:0,
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
    </Filter>
);

const rowStyle = (record) => {
    if (record.commission_ammount <0) return { backgroundColor: '#fdd' };
    
    return {};
};

export const HafkadotList = (props) => (
    <div>
    <List title="פירוט עסקאות" perPage={30} {...props}  filters={<HafkadotFilter /> } style={{color:'red'}}>
      <Responsive
       small={
                   <Datagrid rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            

<DateField label="תאריך הפקדה" format={dateFormatter}  source="deposit_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" format={dateFormatter}  source="rchisha_date.date" locales="he-IL"/>

<TextField label="סוג עסקה" source="tnuaa_type" />




<FunctionField label="סכום עסקה"  style={{overflow:'visible '}} source="schum_iska" render={record =>record.schum_iska.toLocaleString(undefined, {
                        style: 'currency',
                        currency: record.currency,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}/>

<NumberField label="סכום ברוטו לזיכוי"  style={{overflow:'visible '}} locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>



    

    
            <ShowButton />
        </Datagrid>
            }
 medium={

          <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            

<DateField label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="rchisha_date.date" locales="he-IL"/>
<TextField label="סוג עסקה" source="tnuaa_type" />


<FunctionField label="סכום עסקה" source="schum_iska" render={record =>record.schum_iska.toLocaleString(undefined, {
                        style: 'currency',
                        currency: record.currency,
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}/>
                    
<NumberField label="סכום ברוטו לזיכוי"  style={{overflow:'visible '}} locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>



<TextField label="מספר ריכוז"  source="rikuz_number" />
<TextField label="כ.א 4 ספרות" sortable={false}  source="cc_id" />

    

    
            <ShowButton />
        </Datagrid>
       
 }
  
         />
        
    </List>
     <div style={{fontSize:'12'}}>
         פירוט זה ניתן בהסתייגות באופן שרק רישום הפעולות כפי שמופיע בספרי איגוד הסליקה הישראלי בע"מ הוא הקובע את מצב החשבונות. סכום ברוטו, לפני קיזוז עמלות. אם במשך 15 ימים לא תתקבלנה הערות לדוח/מסמך זה, ייחשב הדבר כהודאה בנכונותו. היתרה בדוחות או באישורים מטעם איגוד הסליקה לרבות מסמך זה אינה סופית וכפופה לשינויים ולהפחתות, לרבות בשל ביטולי שוברים או חשש לביטולם או עיכבון או קיזוז או חיובים נוספים בשל הקדמת תשלום ע"ח תקבולים בגין ניכיון שוברים ו/או בגין כל התחייבות ו/או חוב אחר כלפי איגוד הסליקה. ט.ל.ח.</div>
    </div>
);

const HafkadotTitle = ({ record }) => {
    return <span>פרטי עסקה</span>;
};




const HafkadotStyle = {
  width:120,
    minHeight: 50,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top',
    
};
const HafkadotStyleLast = {
  width:120,
    minHeight: 50,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top',
  
    clear:'both'
};
const HafkadotElStyle = {
  width:120,
    minHeight: 50,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top',
    
};

export const HafkadotShow = (props) => (
<div > 
<Show title={<HafkadotTitle />} {...props}>

 <SimpleShowLayout>


  
<DateField style={HafkadotStyle} elStyle={HafkadotElStyle}  label="תאריך עסקה" source="rchisha_date.date" locales="he-IL"/>
<DateField style={HafkadotStyle} elStyle={HafkadotElStyle}  label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>

<TextField style={HafkadotStyle} elStyle={HafkadotElStyle}  label="מספר ריכוז" source="rikuz_number" />

<TextField style={HafkadotStyle} elStyle={HafkadotElStyle} label="קוד אישור" source="kod_ishur" />
<TextField style={HafkadotStyle} elStyle={HafkadotElStyle} label="מספר שובר" source="shovar_number" />
<TextField style={HafkadotStyle} elStyle={HafkadotElStyle} label="מספר כרטיס " source="cc_id" />
<TextField style={HafkadotStyle} elStyle={HafkadotElStyle}  label="סוג עסקה" source="tnuaa_type" />
<NumberField style={HafkadotStyle} elStyle={HafkadotElStyle}  label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField style={HafkadotStyle} elStyle={HafkadotElStyle}  label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>
<TextField style={HafkadotStyle} elStyle={HafkadotElStyle} label="תש' ראשון" source="first_payment" />
<TextField style={HafkadotStyle} elStyle={HafkadotElStyle} label="סכום תשלום" source="total_ammount" />
<TextField style={HafkadotStyle} elStyle={HafkadotElStyle} label="יתרת תשלומים" source="remaining_payments" />

         </SimpleShowLayout>
         
    </Show>
    <div style={HafkadotStyleLast}></div>
         </div>
);




// WEBPACK FOOTER //
// ./src/components/Hafkadot/hafkadot.js